module.exports = __webpack_public_path__ + "img/gun.f2fc4c02.svg";